// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__v_1L3","contentWrapper":"styles_contentWrapper__OzBeY","content":"styles_content__dAbHc"};